export const segments = {
  bulkDensity: 'lab/bulk_density',
  carbon: 'lab/carbon',
};

export const routeParams = {
  barcode: 'barcode',
};

export const routes = {
  bulkDensityInput: (barcode: string) => {
    return `/${segments.bulkDensity}/${barcode}`;
  },
  carbon: segments.carbon,
};
